import BaseScene from './BaseScene'
import { ScorerSpeed, WalkSpeed, BrownianSpeed } from './Constants'
import { delay } from '../helper'
import * as sounds from '../../../constants/Sounds'

export default class Offside extends BaseScene {
    constructor(event, pitch) {
        super(pitch);

        this.Team = event.team;
        if(this.Team == 1)
            this.Linesman = !this.Pitch.props.SidesChanged ? pitch.awayLinesman : pitch.homeLinesman;
        else
            this.Linesman = !this.Pitch.props.SidesChanged ? pitch.homeLinesman : pitch.awayLinesman;
    }

    Play(gameSpeed) {
        return new Promise(function(resolve, reject) {
            
            this.SoundManager.play(sounds.REF);
            this.Linesman.startOffsideAnimation();
            
            this.getPlayers((player) => player.props.index < 11)
                .forEach((player) => player.BrownianMovement(gameSpeed, 25)
                        .then(() => player.WalkToNextPosition(gameSpeed, WalkSpeed)));

            delay(100*gameSpeed).then(resolve);
            
        }.bind(this));
    }
}



/** WEBPACK FOOTER **
 ** ./src/components/Animations/Scenes/Offside.js
 **/